import React from 'react';
import styled from 'styled-components/macro';
import { Card, Row, Col, Icon, Tooltip as AntdTooltip } from 'antd';

import Heading from 'components/Heading/Heading';
import Button from 'components/Button/Button';
import FormSelection from 'components/FormSelection/FormSelection';
import FormCheckbox from 'components/FormCheckbox/FormCheckbox';
import Tooltip from 'components/Tooltip/Tooltip';
import FormToggle from 'components/FormToggle/FormToggle';

import RenoCalculatorIcon from './images/reno-icon.png';

const MainContainer = styled(Card)`
  position: relative;
  @media (min-width: 992px) {
    height: 100%;
  }
`;

const StyledButtonContainer = styled.div`
  display: none;
  @media (min-width: 992px) {
    margin-top: 32px;
    display: block;
  }
`;
const StyledRow = styled.div`
  width: 100% !important;
`;

const TooltipContainer = styled.div`
  margin: 0 0 16px 0;
`;

const NUMBERS_OF_ROOMS = [
  { displayValue: '+1', key: 1 },
  { displayValue: '+2', key: 2 },
  { displayValue: '+3', key: 3 },
  { displayValue: '+4', key: 4 }
];

const RenoCalculatorFilterSection = ({
  form,
  itemsOwnedByUnitSelections,
  onIDServiceToggle,
  onBedroomChange,
  onBathroomChange,
  onItemsOwnedByUnitSelect,
  ...props
}) => {
  return (
    <MainContainer>
      <Row gutter={16} type="flex" justify="space-between" align="top">
        <Col span={4} md={3} style={{ paddingTop: '8px' }}>
          <img src={RenoCalculatorIcon} alt="Reno calculator icon" height={48} />
        </Col>
        <Col span={20} md={21} style={{ wordBreak: 'break-word' }}>
          <Heading color="primary" size="regular">
            Reno Calculator
          </Heading>
        </Col>
      </Row>
      <TooltipContainer>
        <Tooltip message="We have professional interior designers to assist you with your renovation." />
      </TooltipContainer>
      <FormToggle
        size="large"
        label="Do you want to include interior design services?"
        name="isInteriorDesignServiceIncluded"
        form={form}
        onChange={onIDServiceToggle}
      />
      <StyledRow>
        <Row gutter={12}>
          <Col span={12}>
            <FormSelection
              size="large"
              form={form}
              label="Bedrooms"
              name="noOfBedrooms"
              selections={NUMBERS_OF_ROOMS}
              onChange={onBedroomChange}
              defaultValue={1}
            />
          </Col>
          <Col span={12}>
            <FormSelection
              size="large"
              form={form}
              label="Bathrooms"
              name="noOfBathrooms"
              selections={NUMBERS_OF_ROOMS}
              onChange={onBathroomChange}
              defaultValue={1}
            />
          </Col>
        </Row>
      </StyledRow>
      <FormCheckbox
        form={form}
        size="large"
        name="itemsOwnedByUnit"
        label={
          <span>
            What is your unit furnished with?{' '}
            <AntdTooltip title="Existing items will be excluded from the estimation. If your unit is empty, you can skip this section.">
              <Icon type="question-circle" theme="filled" />
            </AntdTooltip>
          </span>
        }
        selections={itemsOwnedByUnitSelections}
        capitalize={false}
        onChange={onItemsOwnedByUnitSelect}
        colSize={{ span: 12 }}
      />
      <StyledButtonContainer>
        <StyledRow>
          <Row gutter={12}>
            <Col span={12}>
              <Button size="default" style={{ width: '100%' }} type="secondary" toUrl="/">
                Home
              </Button>
            </Col>
            <Col span={12}>
              <Button size="default" style={{ width: '100%' }} type="primary" toUrl="/enquiry" prevUrl="/reno-calculator">
                Enquire More
              </Button>
            </Col>
          </Row>
        </StyledRow>
      </StyledButtonContainer>
    </MainContainer>
  );
};

export default RenoCalculatorFilterSection;
